import { Subscription } from 'rxjs';
import { Component, Input, OnDestroy } from '@angular/core';
import { DataStore } from '@common/data-models/data-store/data-store';
import { Record } from "@common/data-models/records/record";
import { TimeoutQueue } from '@common/services/timeout-queue';
import { EnpsSubscriber } from '@common/utils/enps-subscriber';
import { ElementRef } from '@angular/core';
import { BooleanInput, coerceBooleanProperty } from '@angular/cdk/coercion';

declare var serverConfig: { [id: string]: any };

@Component({
    template: ""
})
export class EnpsComponent extends EnpsSubscriber implements OnDestroy {

    @Input() public isNewRecord: boolean = false;

    public static uniqueIdCharacters: string = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    public static uniqueId(len: number) {
        let ret = "";
        for (var i = 0; i < len; i++) {
            ret += EnpsComponent.uniqueIdCharacters.charAt(Math.floor(Math.random() * EnpsComponent.uniqueIdCharacters.length));
        }
        return ret;
    }

    public referalId: string;
    public loading: boolean = false;
    public loaderTimeout;

    public static visualStatesCollection: { [id: string]: Object } = {}

    public get usvSetting(): boolean {
        if (serverConfig["USV"] && serverConfig["USV"].toLowerCase() == "true") {
            return true;
        } else {
            return false;
        }
    }

    public get visualState(): Object {
        if (this._id) {
            if (!EnpsComponent.visualStatesCollection[this._id]) {
                EnpsComponent.visualStatesCollection[this._id] = {};
            }
            return EnpsComponent.visualStatesCollection[this._id];
        } else {
            return null;
        }
    }

    public set visualState(s: Object) {
        if (this._id) {
            EnpsComponent.visualStatesCollection[this._id] = s;
        }
    }

    private _id: string = null;
    @Input()
    public get id(): string {
        return this._id;
    }
    public set id(v: string) {
        if (this._id) {
            delete EnpsComponent.visualStatesCollection[this._id];
        }

        this._id = v;
        if (this._id && !EnpsComponent.visualStatesCollection[this._id]) {
            EnpsComponent.visualStatesCollection[this._id] = {};
        }
    }

    protected _required = false;
    @Input()
    get required() {
        return this._required;
    }
    set required(req: BooleanInput) {
        this._required = coerceBooleanProperty(req);
    }

    constructor(public timeoutQueue: TimeoutQueue) {
        super();
        this.referalId = EnpsComponent.uniqueId(32);
    }

    ngOnDestroy() {
        this.removeAllSubscriptions();
        for (let p of Object.keys(this)) {
            if (
                (this[p] instanceof Record) ||
                (this[p] instanceof Subscription) ||
                (this[p] instanceof EnpsComponent) ||
                (this[p] instanceof ElementRef)
            ) {
                //console.log("set " + this.constructor.name + "." + p + " to null");
                this[p] = null;
            }
        }
        this.subscriptions = new Subscription();
    }

    public showLoader() {
        this.loaderTimeout = this.timeoutQueue.setTimeout(() => {
            this.loading = true;
        }, 200);
    }

    public hideLoader() {
        if (this.loaderTimeout) {
            this.timeoutQueue.clearTimeout(this.loaderTimeout);
        }
        this.loading = false;
    }
}
